import handlebars from "handlebars";
import { GetAppraisalModel } from "../../../../../all_Interfaces";
import currencySymbolMap from "currency-symbol-map";
import cmAppraisalValuesTemplate from "../templates/cmAppraisalValuesTemplate";

export const compileCmAppraisalValuesTemplate = (
    appraisalData:GetAppraisalModel
  ): string => {
    const compiledCmAppraisalValuesTemplate = handlebars.compile(cmAppraisalValuesTemplate);
    const dayjs = require('dayjs');


    var currencySymbol = "$";
    if(appraisalData.currency != "ZH"){
        currencySymbol = currencySymbolMap(appraisalData.currency) as string
    }else{
        currencySymbol = "ZH";
    }
    if(appraisalData.currency == ""){
      currencySymbol = "$";
    }

    var asIsDate = new Date(appraisalData.valueDate);
    var stabilizedDate = new Date(appraisalData.lastAppraisalDate);
    var reoprtDate = new Date(appraisalData.reportDate);
    const asIsDateString:string = asIsDate.toLocaleString();
    const lastDateString:string = stabilizedDate.toLocaleString();
    const reportDateString:string = reoprtDate.toLocaleString();
    // import dayjs from 'dayjs';

    //     const formattedDate = dayjs('14/07/2022, 00:00:00', 'DD/MM/YYYY, HH:mm:ss').format("MMM-DD-YYYY HH:mm:ss");


    
    // Parse the dateString and format it as MMM-DD-YYYY
    // const formattedDate = dayjs(dateString).format("MMM-DD-YYYY HH:mm:ss");
    
    // Output the date in MMM-DD-YYYY format
    // console.log(formattedDate);
    
    const formatNumber = (params:any) => {
        if(params !== null)
          return  params.toLocaleString('en-US');
         ;
      }
      const formatNumberTo0Decimal = (num: any) => {
        const regxmain = /^-?\d+(\.\d+)?$/;
        const regex1 = /^\d+\.\d{1}$/;
        const regx2 = /^\d+$/;
        const regx3 = /^-?\d+\.\d{1}$/; // tocheck - number
        if (regxmain.test(num)) {
          return num.toFixed(2);
        }
        // if (regex1.test(num)) {
        //   return num.toFixed(2);
        // }else  if(regx2.test(num)) {
        //   return num.toFixed(2);
        // }else if(regx3.test(num)){
        //   return `${num.toFixed(2)}`;
        // }
        return num;
      }

    const appraisalValues = {
       asIsPropertyValue:formatNumber(appraisalData.propertyValueAsIs),
       stabilizedValue : formatNumber(appraisalData.propertyValueStabilized),
       insurableValue:formatNumber(appraisalData.propertyInsurableValue),
       landValue: formatNumber(appraisalData.propertyLandValue),

       currency:appraisalData.currency,
       currencySymbol: currencySymbol,

       asIscapRate : formatNumberTo0Decimal(appraisalData.capRateAsIs),
       stabilizedcapRate : formatNumberTo0Decimal(appraisalData.capRateStabilized),
       
       propertyAsIsDate:dayjs(asIsDateString, 'M/D/YYYY, h:mm:ss A').format("MMM-DD-YYYY HH:mm:ss"),
       propertyStabilizedDate:dayjs(lastDateString, 'M/D/YYYY, h:mm:ss A').format("MMM-DD-YYYY HH:mm:ss"),
       reportDate:dayjs(reportDateString, 'M/D/YYYY, h:mm:ss A').format("MMM-DD-YYYY HH:mm:ss"),
    }

    return compiledCmAppraisalValuesTemplate(appraisalValues);
}